"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,11.4c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2S14.8,11.4,12.5,11.4z M12.5,4.1 c-1.7,0-3.2,1.4-3.2,3.2c0,1.7,1.4,3.2,3.2,3.2c1.7,0,3.2-1.4,3.2-3.2C15.7,5.5,14.2,4.1,12.5,4.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,22.9c-0.2,0-0.3-0.1-0.4-0.2c-0.3-0.4-7.2-11-7.2-15.1C4.8,3.4,8.3,0,12.5,0s7.7,3.4,7.7,7.7 c0,4.1-6.9,14.6-7.2,15.1C12.8,22.9,12.7,22.9,12.5,22.9z M12.5,1C8.8,1,5.8,4,5.8,7.7c0,3.2,5.1,11.5,6.7,13.9 c1.5-2.4,6.7-10.6,6.7-13.9C19.2,4,16.2,1,12.5,1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,25C12,25,0,25,0,22.4c0-1.2,2.4-2,7.2-2.4c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5c-4.8,0.4-6.2,1.2-6.3,1.4 C1.3,23,5.4,24,12.5,24s11.2-1,11.5-1.6c-0.1-0.2-1.5-0.9-6.3-1.3c-0.3,0-0.5-0.3-0.5-0.5c0-0.3,0.3-0.5,0.5-0.5 c4.8,0.4,7.2,1.2,7.2,2.4C25,25,13,25,12.5,25z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M0.5,11.6"
  }));
};

exports["default"] = _default;